import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import QuotePreview from "@/pages/QuotePreview";
import LoadingPage from "@/pages/LoadingPage";
import CookieConsent from "@/components/CookieConsent";
import { captureLeadSource } from "@/utils/leadSource";

function App() {
  useEffect(() => {
    captureLeadSource();
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/arajanlat/:id" element={<QuotePreview />} />
          <Route path="/adatkezeles" element={<LoadingPage />} />
          <Route path="/aszf" element={<LoadingPage />} />
        </Routes>
      </BrowserRouter>
      <CookieConsent />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
